import webuiState from "../app/InternalStateService";
import utilityService from "../app/UtilityService";
import translationService from "../app/TranslationService";
import promiseAllSettled from "../utils/promiseAllSettled";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

const STEP_POST_REQUEST = "STEP_POST_REQUEST";
const STEP_POST_ONLY_SUCCESS = "STEP_POST_ONLY_SUCCESS";

function processStep(processAction, stepData, stepIndex, widgetId) {
    return async (dispatch, getState) => {
        let result = await dispatch(validatePostStep(processAction, stepData, stepIndex, widgetId));
        dispatch(
            webuiState.getActionByName("flow.realodFlowOnProcessStep")(widgetId, stepData.step)
        );
        return result;
    };
}
//validates and posts a step
function validatePostStep(processAction, stepData, stepIndex, widgetId) {
    const postStep = webuiState.getActionByName("flow.postStep");
    const validateStepData = webuiState.getActionByName("validations.validateStepData");
    return (dispatch, getState) => {
        var isValidationPassed = dispatch(validateStepData(stepData, stepIndex, widgetId));
        WEBUILogs.log("validatePostStep");
        if (isValidationPassed) {
            if (processAction) {
                return dispatch(
                    postStep(processAction.href, widgetId, stepData.step, processAction)
                );
            } else {
                WEBUILogs.error("Missing processStep action.");
            }
        } else {
            dispatch(
                webuiState.getActionByName("messages.triggerMessages")([
                    {
                        type: "error",
                        messages: [translationService.translate("enterValidInfo")]
                    }
                ])
            );
        }
        //in case the validation fails return rejected Promise
        //for chaninig purposes
        return Promise.reject("Promise: ProcessStep action failed.");
    };
}

export function processStepFromSirenAction(sirenAction, widgetId, path) {
    var stepId = Array.isArray(path) ? path[1] : path.split(".")[1];
    return (dispatch, getState) => {
        var stepsInFlow = getState()
            .getIn(["data", widgetId, "entities"])
            .toJS();

        var stepIndex = stepsInFlow.findIndex(step => {
            return step.step === stepId;
        });

        var stepData = stepsInFlow[stepIndex];

        return dispatch(processStep(sirenAction, stepData, stepIndex, widgetId));
    };
}

export function processAllSteps(widgetId) {
    return async (dispatch, getState) => {
        var steps = getState().getIn(["data", widgetId, "entities"]);
        var pendingSteps = [];
        //promises for savesStep actions on pending steps
        var processingSteps;

        steps.forEach((step, stepIndex) => {
            var stepData;
            var processStepAction;

            if (step.getIn(["properties", "status"]) === "pending") {
                stepData = step.toJS();
                processStepAction = stepData.actions.find(action => {
                    return action.actionType === "processStep";
                });
                pendingSteps.push({
                    stepIndex: stepIndex,
                    stepData: stepData,
                    processStepAction: processStepAction
                });
            }
        });

        processingSteps = pendingSteps.map(step => {
            return dispatch(
                validatePostStep(step.processStepAction, step.stepData, step.stepIndex, widgetId)
            );
        });

        await promiseAllSettled(processingSteps);
        return dispatch(webuiState.getActionByName("flow.reloadFlow")(widgetId));
    };
}

export function triggerShowPreviousStep(sirenAction, widgetId, path) {
    var stepId = path.split(".")[1];

    return showPreviousStep(widgetId, stepId);
}

export function showPreviousStep(widgetId, stepId) {
    WEBUILogs.log("showPreviousStep");
    return (dispatch, getState) => {
        //get previous stepId
        var steps = getState().getIn(["data", widgetId, "entities"]);
        var newVisibleStepId;
        var newVisibleStepIndex;

        var stepIdx = steps.findIndex(step => {
            return step.getIn(["step"]) === stepId || step.getIn(["class", 0]) === stepId;
        });

        newVisibleStepIndex = stepIdx - 1;
        if (newVisibleStepIndex < 0) {
            newVisibleStepIndex = 0;
        }

        newVisibleStepId = steps.getIn([newVisibleStepIndex, "step"]);
        if (!newVisibleStepId) {
            newVisibleStepId = steps.getIn([newVisibleStepIndex, "class", 0]);
        }

        return dispatch(showAnotherStep(widgetId, newVisibleStepId));
    };
}

//get View for a step and show it
export function showAnotherStep(widgetId, stepId) {
    WEBUILogs.log("showAnotherStep");
    return (dispatch, getState) => {
        return dispatch(
            webuiState.getActionByName("flow.setFlowUiState")(widgetId, {
                visibleStep: stepId
            })
        );
    };
}

export function saveStepFromSirenAction(sirenAction, widgetId, path) {
    var stepId = Array.isArray(path) ? path[1] : path.split(".")[1];
    return (dispatch, getState) => {
        var stepsInFlow = getState()
            .getIn(["data", widgetId, "entities"])
            .toJS();

        var stepIndex = stepsInFlow.findIndex(step => {
            return step.step === stepId;
        });

        var stepData = stepsInFlow[stepIndex];

        return dispatch(saveStep(getState, sirenAction, stepData, stepIndex, widgetId));
    };
}

//validates and posts a step, then it does nothing
function saveStep(getState, action, stepData, stepIndex, widgetId) {
    const hasStepErrors = webuiState.getActionByName("flow.hasStepErrors");
    const validateStepData = webuiState.getActionByName("validations.validateStepData");
    return async (dispatch, getState) => {
        WEBUILogs.log("saveStep");
        //in the action - parameter for validation is passed
        //the default behavior is always to have validation
        var stepValidation = true;
        if (action.validation || action.validation === false) {
            stepValidation = action.validation;
        }

        var isValidationPassed;

        if (stepValidation) {
            isValidationPassed = dispatch(validateStepData(stepData, stepIndex, widgetId));

            if (!isValidationPassed) {
                return Promise.reject(
                    dispatch(
                        webuiState.getActionByName("messages.triggerMessages")([
                            {
                                type: "error",
                                messages: [translationService.translate("enterValidInfo")]
                            }
                        ])
                    )
                );
            }
        }

        if (!action) {
            return Promise.reject(
                dispatch(
                    webuiState.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [
                                `Ops! Unable to process.
                         No proper processStep action defined for this step!`
                            ]
                        }
                    ])
                )
            );
        }
        await dispatch(postOnlyStep(action.href, widgetId, stepData.step, action));

        let hasErrors = hasStepErrors(getState().getIn(["data", widgetId, "entities", stepIndex]));

        if (hasErrors) {
            //scrolling to show errors
            webuiState.getActionByName("scroll.scrollToTop")();
            return Promise.reject("Save step actions results in errors.");
        }
    };
}

function postOnlyStep(endpoint, widgetId, stepId, sirenAction) {
    WEBUILogs.log("postOnly Step");
    return (dispatch, getState) => {
        var payload = {};
        var flow = getState()
            .getIn(["data", widgetId])
            .toJS();
        if (flow.entities) {
            var stepContent = flow.entities.find(step => step.step === stepId);
            if (!stepContent) stepContent = {};

            if (stepContent) {
                payload = utilityService
                    .getUtils()
                    .createFormData(stepContent, sirenAction, undefined, widgetId);
            }
        }
        dispatch(
            webuiState.getActionByName("component.setUiState")(widgetId, stepId, {
                isLoading: true
            })
        );
        return dispatch(requestSubmitOnlyStep(endpoint, "POST", widgetId, stepId, payload));
    };
}

function requestSubmitOnlyStep(endpoint, method, widgetId, stepId, payload) {
    WEBUILogs.log("requestSubmitOnlyStep.");
    return async dispatch => {
        let actionResult;
        try {
            await dispatch({
                type: STEP_POST_REQUEST
            });
            actionResult = await dispatch(
                webuiState.getActionByName("request.request")(
                    {
                        endpoint: endpoint,
                        method: method,
                        headers: {
                            "Content-Type": `multipart/form-data`
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            if (Object.keys(actionResult).length === 0) {
                actionResult = { isEmpty: true };
            }
            dispatch({
                type: STEP_POST_ONLY_SUCCESS,
                payload: Object.assign({}, actionResult, {
                    widgetId: widgetId,
                    step: stepId
                })
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    webuiState.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("stepPostFailure")]
                        }
                    ])
                );
            }
        } finally {
            dispatch(
                webuiState.getActionByName("component.setUiState")(widgetId, stepId, {
                    isLoading: false
                })
            );
        }
        return actionResult;
    };
}
